<template>
  <div :class="`${skinClass}`">
    <router-view v-if="!$store.state.app.denyDesktop"></router-view>
    <div v-else class="pd-10 text-muted">Хандах боломжгүй !</div>

    <!-- <skin-golomt /> -->
    <div v-if="$store.state.app.activeGroup.id == 9311 && !mntd" style="margin: 0 auto; text-align: center; width: 250px; margin-top: 30vh;">
      <img src="https://res.gosmart.mn/media/logo/masd.png" style="text-align: center; width: 100%;" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import config from "@/config";
const { lmsPages } = config;
import { hasOneOf } from "@/libs/tools";

export default {
  name: "App",
  data() {
    return {
      skinClass: "",
      mntd: false,
    };
  },
  beforeCreate() { 
    if (this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249){
      import('@/assets/scss/overrides/_golomt.scss');
    } else if (this.$store.state.app.activeGroup.id == 9254){
      import('@/assets/scss/overrides/_state.scss');
    } else if (this.$store.state.app.activeGroup.id == 9358){
      import('@/assets/scss/overrides/_resparliament.scss');
    } else if (this.$store.state.app.activeGroup.id == 9132){
      import('@/assets/scss/overrides/_mnuac.scss');
    } else if (this.$store.state.app.activeGroup.id == 9307){
      import('@/assets/scss/overrides/_jud.scss');
    } else if (this.$store.state.app.activeGroup.id == 9291) {
      import('@/assets/scss/overrides/_khudulmur.scss');
    } else if (this.$store.state.app.activeGroup.id == 9357) {
      import('@/assets/scss/overrides/_mmse.scss');
    } else if (this.$store.state.app.activeGroup.id == 9352) {
      import('@/assets/scss/overrides/_capitronbank.scss');
    } else if (this.$store.state.app.activeGroup.id == 6126) {
      import('@/assets/scss/overrides/_cpta.scss');
    } else if (this.$store.state.app.activeGroup.id == 9157) {
      import('@/assets/scss/overrides/_monicpa.scss');
    } else if (this.$store.state.app.activeGroup.id == 9272) {
      import ('@/assets/scss/overrides/_youth.scss');
      import ('@/assets/css/ubtz/bootstrap.css');
      import ('@/assets/css/ubtz/css2.css');
      import ('@/assets/css/ubtz/nemelt.css');
    }

    if (this.$store.state.app.activeGroup?.namespace == 'stf.project' || this.$store.state.app.activeGroup.id == 9298) {
      import('@/assets/scss/overrides/_stf.scss');
    } else if (this.$store.state.app.activeGroup?.namespace == 'stf.doctor') {
      import('@/assets/scss/overrides/_stfdoctor.scss');
    } else if (this.$store.state.app.activeGroup?.namespace == 'stf.researcher') {
      import('@/assets/scss/overrides/_stfresearcher.scss');
    } else if (this.$store.state.app.activeGroup?.namespace == 'stf.startup') {
      import('@/assets/scss/overrides/_stfstartup.scss');
    } else if (this.$store.state.app.activeGroup.id == 100){
      import('@/assets/scss/overrides/_mta.scss');
    } else if (this.$store.state.app.activeGroup.id == 9360){
      import('@/assets/scss/overrides/_crc.scss');
    } else if (this.$store.state.app.activeGroup.id == 9366){
      import('@/assets/scss/overrides/_orgil.scss');
    } else if (this.$store.state.app.activeGroup.id == 9365){
      import('@/assets/scss/overrides/_pittc.scss');
    } else if (this.$store.state.app.activeGroup.id == 9371){
      import('@/assets/scss/overrides/_mmart.scss');
    } else if (this.$store.state.app.activeGroup.id == 9372){
      import('@/assets/scss/overrides/_metal.scss');
    } else if (this.$store.state.app.activeGroup.id == 9373){
      import('@/assets/scss/overrides/_etailan.scss');
    } else if (this.$store.state.app.activeGroup.id == 9379){
      import('@/assets/scss/overrides/_egazar.scss');
    } else if (this.$store.state.app.activeGroup.id == 9385){
      import('@/assets/scss/overrides/_orchedu.scss');
    } else if (this.$store.state.app.activeGroup.id == 9386){
      import('@/assets/scss/overrides/_khugjil.scss');
    } else if (this.$store.state.app.activeGroup.id == 9387){
      import('@/assets/scss/overrides/_bichil-uurkhai.scss');
    }

    if (this.$store.state.app.activeGroup.id == 9263) {
      document.title = "Оюуны өмчийн газар";
      var links = document.querySelectorAll("link[rel~='icon'");
      if (links.length == 0) {
        let link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
        links = document.querySelectorAll("link[rel~='icon'");
      }
      links.forEach(link => {
        link.href = "https://res.gosmart.mn/apps/ipom/fav.png";
      });
    } else if (this.$store.state.app.activeGroup.id == 9287) {
      document.title = "Дотоод аудитын систем";
      var links = document.querySelectorAll("link[rel~='icon'");
      if (links.length == 0) {
        let link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
        links = document.querySelectorAll("link[rel~='icon'");
      }
      links.forEach(link => {
        link.href = "https://res.gosmart.mn/media/logo/soyombo.png";
      });
    }
  },
  mounted() {
    this.mntd= true;
    //console.log('app page fired');

    this.checkMobile();
    this.skinOverride();

    // console.log(this.$store.state.signalr.osrCon);

    // this.$store.state.signalr.osrCon.on("receiveGlobalNotification", e => {
    //   if(e.notification.type==3){
    //     this.$router.push(e.notification.link);
    //   }
    //   //console.log(e);
    // });
  },
  created() { 
    // if (hasOneOf(lmsPages, [this.$route.name])) {
    //   import('@/assets/scss/tailwind.scss');
    // }
    // else {
    //   const styleElement = document.querySelector('link[href*="tailwind.scss"]');
    //   if (styleElement) {
    //     styleElement.parentNode.removeChild(styleElement);
    //   }
    // }
  },
  methods: {
    ...mapActions(["handleIsMobile", "handleDenyDesktop"]),
    checkMobile() {
      //console.log('checkMobile fired');
      if (screen.width <= 1023) {
        //console.log('screen.width <= 1024', screen.width <= 1024);
        this.handleIsMobile(true);
      } else if (
        !this.$store.state.app.isMobile &&
        (document.location.hostname == "academy.golomtbank.com" ||
          document.location.hostname == "www.academy.golomtbank.com")
        //|| document.location.hostname == "192.168.0.105"
      ) {
        this.handleDenyDesktop(true);
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    skinOverride() {
      // let currentApp=config.mobApps.filter(x=>x.id == mobAppActiveGroup);
      // if(currentApp.length>0){
      //   this.skinClass=currentApp[0].skin;
      // }
      //console.log('this.$store.state.app.activeGroup', this.$store.state.app.activeGroup);
      this.skinClass = this.$store.state.app.activeGroup.skin;
      if (this.$store.state.app.skin.dark) {
        this.toggleBodyClass("addClass", "is-dark");
      }

      //this.myMobAppActiveGroup = mobAppActiveGroup;
      // if(this.$route.name=='lmsParticipant'){
      //   require('@/assets/css/dashforge.profile.css');
      // }

      // if (mobAppActiveGroup == 9241) {
      // //require('@/assets/css/custom/golomt.less');
      // require("@/assets/scss/overrides/_golomt.scss");
      // }

      // if (this.$store.state.app.skin.dark) {
      //   //require("@/assets/css/skin.dark.css");
      //   require("@/assets/scss/skins/dark.scss");
      // }
    }
  }
};
</script>
